import React, { useCallback, useEffect, useState } from 'react'
import { Container } from '@mui/material'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  useTranslate,
  useListController,
  useRefresh,
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { RouteConfigImportButton } from './logic/RouteConfigImportButton'
import { RouteConfigExportButton } from './logic/RouteConfigExportButton'

export const RouteConfigList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const refresh = useRefresh()

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = useCallback(
    (sort) => {
      setSort(sort)
      setIsSorting(true)
    },
    [setSort]
  )

  const handleImportFinished = useCallback(() => {
    refresh()
  }, [refresh])

  const RouteConfigImportButtonWithRefresh = useCallback(
    () => <RouteConfigImportButton onImportFinished={handleImportFinished} />,
    [handleImportFinished]
  )

  const RouteConfigExportButtonWithProps = useCallback(() => <RouteConfigExportButton />, [])

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.route-config')}>
        <List
          {...props}
          component='div'
          bulkActionButtons={false}
          exporter={false}
          empty={false}
          actions={
            <ListViewTopToolbar
              hasCreate={false}
              customFilter
              exporterDisable
              CustomImportButton={RouteConfigImportButtonWithRefresh}
              CustomExportButton={RouteConfigExportButtonWithProps}
            />
          }
        >
          <Datagrid
            rowClick='none'
            setSort={onClickSort}
            isLoading={isLoading}
            bulkActionButtons={false}
          >
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='work_unit_name' label={translate('ra.field.work_unit')} />
            <TextField source='origin' label={translate('ra.field.origin')} />
            <TextField source='destination' label={translate('ra.field.destination')} />
            <TextField source='days_of_week' label={translate('ra.field.days_of_week')} />
            <DateField source='date_start' label={translate('ra.field.initial_date')} />
            <DateField source='date_end' label={translate('ra.field.final_date')} />
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
